export const enum A360ProductCd {
  HI = 'HI',
  CI = 'CI',
  ACC = 'ACC',
  GPLU = 'GPLU',
}

export const enum A360ProductModel {
  HIMaster = 'HIMaster',
  CIMaster = 'CIMaster',
  ACCMaster = 'ACCMaster',
  GPLUMaster = 'GPLUMaster',
}

export const enum A360Plan {
 GCI5 = "GCI5",
 GVCI4 = "GVCI4",
 GHI3 = "GHI3",
 GIM2 = "GIM2",
 GVA6 = "GVA6",
 GAI7 = "GAI7",
 GPLU = "Plan1",
}

export const enum A360Product {
  HospitalIndemnity = 'Hospital Indemnity',
  CriticalIllness = 'Critical Illness',
  Accident = 'Accident',
  GroupWholeLife = 'Group Whole Life',
}

export const enum LevelValues {
  Policy = 'POLICY',
}

export type ProductType = 'HEALTH' | 'LIFE';

export interface Product {
  name: string;
  code: A360ProductCd;
  _model: A360ProductModel;
  _type?: ProductType;
}
